import React, { useState, useEffect } from 'react';
import './OtherPractices.css';
import { useTranslation } from 'react-i18next';
import otherPracticeImg from '../../assets/images/Home/other-pracitces.png';

const OtherPractices = () => {
  const { t } = useTranslation();
  const ts = (k, d) => t(`sections.otherPractices.${k}`, d);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  const otherPracticesArr = ts('items', { returnObjects: true }) || [];

  // Определение типа устройства
  useEffect(() => {
    const checkIfMobile = () => {
      // 1024px - брейкпоинт для планшетов и мобилок
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Определяем, какие элементы показывать
  const shouldShowAll = !isMobile || isExpanded;
  const itemsToShow = shouldShowAll 
    ? otherPracticesArr 
    : otherPracticesArr.slice(0, 14);
  
  // Разделяем элементы на две колонки
  const midIndex = Math.ceil(itemsToShow.length / 2);
  const leftColumnItems = itemsToShow.slice(0, midIndex);
  const rightColumnItems = itemsToShow.slice(midIndex);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="other-practices-container">
      <div className="other-practices-left">
        <h2 className="other-practices-title">
          {ts('title')}
        </h2>
        <div className="other-practices-keys">
          <div>
            {leftColumnItems.map((el, index) => (
              <div className="other-practices-items-left" key={index}>
                {el}
              </div>
            ))}
          </div>
          <div>
            {rightColumnItems.map((el, index) => (
              <div className="other-practices-items-right" key={index + leftColumnItems.length}>
                {el}
              </div>
            ))}
          </div>
        </div>
        
        {/* Кнопка показывается только на мобилках и планшетах */}
        {isMobile && otherPracticesArr.length > 14 && (
          <button 
            className="show-more-button" 
            onClick={toggleExpand}
          >
            {isExpanded ? ts('showLess') : ts('showMore')}
          </button>
        )}
      </div>
      <div className="other-practices-right">
        <img src={otherPracticeImg} alt={ts('imgAlt')} />
      </div>
    </div>
  );
};

export default OtherPractices;